import { React, useContext } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Button } from '@digsup/components-button';
import { Icon } from '@digsup/components-icon';
import { ModalContext } from './Modal';

export const ControlBtn = ({ type, onClick, children, ...props }) => {
  const { setDirection } = useContext(ModalContext);

  if (type === 'prev')
    return (
      <Button
        icon={<Icon name="arrow-long-left" size="medium" />}
        iconOnly
        type="button"
        variant="tertiary"
        className="u-margin-right-small u-padding-right-large u-padding-left-large"
        style={{ minWidth: 82 }}
        onClick={() => {
          setDirection('prev');
          if (onClick) {
            onClick();
          }
        }}
        {...props}>
        {children}
      </Button>
    );

  if (type === 'next')
    return (
      <Button
        width="full"
        icon={<Icon name="arrow-long-right" size="medium" slot="right" />}
        onClick={() => {
          setDirection('next');
          if (onClick) {
            onClick();
          }
        }}
        type="submit"
        {...props}>
        <span className="u-margin-right-small">{children}</span>
      </Button>
    );

  return (
    <Button
      onClick={() => {
        setDirection('next');
        if (onClick) {
          onClick();
        }
      }}
      type="submit"
      width="full"
      {...props}>
      {children}
    </Button>
  );
};

ControlBtn.propTypes = {
  type: PropTypes.oneOf(['prev', 'next', 'default']),
  onClick: PropTypes.func,
  children: PropTypes.any,
};

ControlBtn.defaultProps = {
  type: 'default',
  onClick: null,
};
